export default "__VITE_ASSET__B4pFLBe7__"